import { autoinject, Aurelia } from 'aurelia-framework';
import { Router } from 'aurelia-router';

@autoinject
export class StepIndicator {

    constructor(private aurelia: Aurelia, public router: Router) {
    }


    steps: Array<string>;
    activeStep: string;
    navigationCompleteSub: any;

    bind() {
        this.navigationCompleteSub = (<any>this.aurelia).subscribe('router:navigation:complete', msg => this.onNavigationComplete(msg));
    }

    unbind() {
        this.navigationCompleteSub.dispose();
    }

    onNavigationComplete(msg) {
        if (!msg.result.completed) {
            return;
        }
    }

}